import React from 'react';
type CtaButtonProps = {
  children: React.ReactNode;
  size?: 'lg' | 'xl';
  fullWidth?: boolean;
  href?: string;
};
declare global {
  interface Window {
    fbq?: any;
  }
}
export function CtaButton({
  children,
  size = 'lg',
  fullWidth = false,
  href = '#oferta'
}: CtaButtonProps) {
  const sizing = size === 'xl' ? 'px-10 py-5 text-base md:text-lg' : 'px-8 py-4 text-sm md:text-base';
  const handleClick = () => {
    if (href === 'https://metodo-para-padres-de-futbolistas-latam.impultienda.ar/checkout' && window.fbq) {
      window.fbq('track', 'InitiateCheckout', {
        value: 15,
        currency: 'USD'
      });
    }
  };
  return <a href={href} onClick={handleClick} style={{
    textAlign: 'center',
    justifyContent: 'center',
    display: 'inline-flex',
    alignItems: 'center'
  }} className={`rounded-full bg-brand-greenCta font-extrabold uppercase tracking-wide text-white shadow-cta transition-[background-color,transform] duration-150 ease-out hover:bg-brand-greenCtaHover hover:-translate-y-0.5 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-brand-green ${sizing} ${fullWidth ? 'w-full' : ''}`} data-id="element-232" data-mp="1h61q51rtr7jl">
      {children}
    </a>;
}